import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedPackage: null,
};

const packageSlice = createSlice({
  name: "package",
  initialState,
  reducers: {
    setSelectedPackage: (state, action) => {
      state.selectedPackage = action.payload;
      localStorage.setItem("selectedPackage", JSON.stringify(action.payload));
    },
    clearSelectedPackage: (state) => {
      localStorage.removeItem("package");
      return null;
    },
  },
});

export const { setSelectedPackage, clearSelectedPackage } =
  packageSlice.actions;
export default packageSlice.reducer;
